export default __webpack_public_path__ + "static/media/34.290a9952.png";